import React from 'react';

import { Route, Routes } from 'react-router';

import ReportedUserEdit from './ReportedUserEdit';
import ReportedUsersList from './ReportedUsersList';
import UserEdit from './UserEdit';
import UserList from './UserList';

function UserModule() {
  return (
    <Routes>
      <Route path="" element={<UserList />} />
      <Route path=":id" element={<UserEdit />} />
      <Route path="reported" element={<ReportedUsersList />} />
      <Route path="reported/:id" element={<ReportedUserEdit />} />
    </Routes>
  );
}

export default UserModule;
